import React, { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { projects } from "../../mock";
import { Eyebrow, SectionTitle } from "./Sections";

const cats = ["All", ...Array.from(new Set(projects.map((p) => p.category)))];

export default function Projects() {
  const [showAll, setShowAll] = useState(false);
  const [cat, setCat] = useState("All");
  const navigate = useNavigate();

  const filtered = projects.filter((p) => cat === "All" || p.category === cat);
  const list = showAll ? filtered : filtered.slice(0, 4);

  return (
    <section id="projects" className="bg-[#141416] py-28">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-[13.3%]">
        <div className="reveal flex flex-wrap items-end justify-between gap-6">
          <div><Eyebrow>Portfolio</Eyebrow><SectionTitle>Featured Projects</SectionTitle></div>
          <button
            onClick={() => setShowAll(!showAll)}
            data-testid="all-projects-btn"
            className="group flex items-center gap-2 border border-white/25 rounded-full px-6 py-3 text-white text-[14px] tracking-[0.12em] hover:bg-yellow-400 hover:text-black hover:border-yellow-400 transition-colors duration-300"
          >
            {showAll ? "SHOW LESS" : "ALL PROJECTS"} <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform" />
          </button>
        </div>

        {showAll && (
          <div className="mt-10 flex flex-wrap gap-2">
            {cats.map((c) => (
              <button
                key={c}
                data-testid={`filter-${c}`}
                onClick={() => setCat(c)}
                className={`rounded-full px-5 py-2 text-sm font-mono-x transition-colors duration-200 ${cat === c ? "bg-yellow-400 text-black" : "bg-zinc-800 text-white/70 hover:text-white"}`}
              >
                {c}
              </button>
            ))}
          </div>
        )}

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((p) => (
            <div
              key={p.id}
              data-testid={`project-card-${p.id}`}
              onClick={() => navigate(`/projects/${p.slug}`)}
              className="group cursor-pointer rounded-3xl overflow-hidden bg-zinc-900 border border-white/10 hover:border-yellow-400/50 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_-24px_rgba(0,0,0,0.9)] transition-[transform,border-color,box-shadow] duration-300"
            >
              <div className="relative h-[260px] overflow-hidden">
                <img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                <span className="absolute top-4 left-4 bg-zinc-900/80 backdrop-blur text-white text-[11px] font-mono-x px-3 py-1 rounded-full">{p.category}</span>
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <span className="w-14 h-14 rounded-full bg-yellow-400 flex items-center justify-center scale-75 group-hover:scale-100 transition-transform duration-300">
                    <ArrowUpRight className="w-6 h-6 text-black" />
                  </span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-white text-[20px] font-bold">{p.title}</h3>
                <div className="flex justify-between items-center mt-1.5">
                  <span className="text-white/50 text-[13px]">{p.location}</span>
                  <span className="font-mono-x text-yellow-400 text-[12px]">{p.year}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

    </section>
  );
}
